<div class="rankings-page">
    <div class="cat_toppers_iq cat_success_stories toppers-all">

        <div class="container">
    
            <div class="row">
                <div class="col-md-12">
                    <div class="cat_success_stories_wrapper pt-5 pb-4 px-4">
    
                        <div class="result-header-text d-md-flex align-items-center justify-content-between mb-4 position-relative">
                            <h2 class="mb-0">iQuanta<span> Toppers</span></h2>
    
                            <div class="toppers-year-filter">
                                <button (click)="changeTab('all')" [ngClass]="{'active': tabVal == 'all'}" class="btn">All</button>
                                <button (click)="changeTab('2024')" [ngClass]="{'active': tabVal == '2024'}" class="btn">2024</button>
                                <button (click)="changeTab('2023')" [ngClass]="{'active': tabVal == '2023'}" class="btn">2023</button>
                                <button (click)="changeTab('2022')" [ngClass]="{'active': tabVal == '2022'}" class="btn">2022</button>
                                <button (click)="changeTab('2021')" [ngClass]="{'active': tabVal == '2021'}" class="btn">2021</button>
                                <button (click)="changeTab('2020')" [ngClass]="{'active': tabVal == '2020'}" class="btn">2020</button>
                                <button (click)="changeTab('2019')"  [ngClass]="{'active': tabVal == '2019'}" class="btn">2019</button>
                                <button (click)="changeTab('2018')" [ngClass]="{'active': tabVal == '2018'}" class="btn">2018</button>
                                <button (click)="changeTab('2017')" [ngClass]="{'active': tabVal == '2017'}" class="btn">2017</button>
                                <button (click)="changeTab('2016')" [ngClass]="{'active': tabVal == '2016'}" class="btn">2016</button>
                                <button (click)="changeTab('2015')" [ngClass]="{'active': tabVal == '2015'}" class="btn">2015</button>
                            </div>
                        </div>
    
                        <div class="toppers-list-items">
                            <div class="toper_tab_imgs">
                                <div>
                                    <ul class="nav">
                                        <li *ngFor="let topper of toppersListSelected.slice(0, viewCount)">
                                            <img src="{{topper?.img}}" alt="{{topper.name}}">
                                            <h4>{{topper.name}}</h4>
                                            <p>{{topper.persentage}} </p>
                                        </li>
                                    </ul>
    
                                    <div class="view-more text-center mt-5">
                                        <button *ngIf="viewCount < toppersListSelected.length" mat-button (click)="viewMore('2')">
                                            View More
                                        </button>
    
                                        <button *ngIf="viewCount >= toppersListSelected.length" mat-button (click)="viewLess('2')">
                                            View Less
                                        </button>
                                    </div>
                                </div>
    
                            </div>
                        </div>
    
    
                    </div>
    
                </div>
            </div>
    
        </div>
    
    
    
    
    
    </div>
</div>

